import ErrorMessage from '../components/common/ErrorMessage';

export default function ErrorPage() {
  return (
    <div className="flex items-center justify-center py-16">
      <ErrorMessage
        title="Seite nicht gefunden"
        message="Die angeforderte Seite existiert nicht oder der Link ist ungültig."
      />
    </div>
  );
}
